export default __webpack_public_path__ + "static/media/face_1_41.08fe34b0.png";